"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/search/selectors");
var _reselect = require("reselect");
var _excluded = ["queriesIDs"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var INITIAL_PROGRESS_PERCENT = 0;
var FIRST_STEP_PROGRESS_PERCENT = 20;
var MAX_PROGRESS_PERCENT = 100;
var STATIC_PERCENT_BY_ONE_TIC = 0.5;
var createGetSearchProgressByPercent = function createGetSearchProgressByPercent(queriesIDs) {
  return _reselect.createSelector.apply(void 0, _toConsumableArray(R.map(function (queryID) {
    return R.partialRight(_selectors.getSearchProgressByPercent, [{
      queryID: queryID
    }]);
  }, queriesIDs)).concat([function () {
    for (var _len = arguments.length, percents = new Array(_len), _key = 0; _key < _len; _key++) {
      percents[_key] = arguments[_key];
    }
    return R.sum(percents) / R.length(percents);
  }]));
};
var withHorizontalLoaderProps = function withHorizontalLoaderProps(Component) {
  var WithHorizontalLoaderProps = function WithHorizontalLoaderProps(_ref) {
    var queriesIDs = _ref.queriesIDs,
      props = _objectWithoutProperties(_ref, _excluded);
    var getSearchProgress = (0, _react.useMemo)(function () {
      return createGetSearchProgressByPercent(queriesIDs);
    }, [queriesIDs]);
    var searchProgress = (0, _reactRedux.useSelector)(getSearchProgress);
    var _useState = (0, _react.useState)(INITIAL_PROGRESS_PERCENT),
      _useState2 = _slicedToArray(_useState, 2),
      commonProgress = _useState2[0],
      setCommonProgress = _useState2[1];
    (0, _react.useEffect)(function () {
      if (searchProgress) {
        global.window.requestAnimationFrame(function () {
          return setCommonProgress(function (prevProgress) {
            return Math.min(MAX_PROGRESS_PERCENT, searchProgress >= prevProgress ? searchProgress : R.add(prevProgress - searchProgress, searchProgress));
          });
        });
      }
    }, [searchProgress]);
    (0, _react.useEffect)(function () {
      var timerID = setInterval(function () {
        return global.window.requestAnimationFrame(function () {
          return setCommonProgress(function (prev) {
            return prev === INITIAL_PROGRESS_PERCENT ? FIRST_STEP_PROGRESS_PERCENT : prev >= MAX_PROGRESS_PERCENT ? (clearInterval(timerID), prev) : prev + STATIC_PERCENT_BY_ONE_TIC;
          });
        });
      }, 300);
      return function () {
        return clearInterval(timerID);
      };
    }, []);
    return /*#__PURE__*/_react.default.createElement(Component, _extends({
      progress: commonProgress
    }, props));
  };
  WithHorizontalLoaderProps.propTypes = {
    queriesIDs: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
  };
  return WithHorizontalLoaderProps;
};
var _default = exports.default = withHorizontalLoaderProps;